import { render, staticRenderFns } from "./FatturaLavorazione.vue?vue&type=template&id=b9380cec"
import script from "./FatturaLavorazione.vue?vue&type=script&lang=js"
export * from "./FatturaLavorazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports